import { api } from './graphql';

api.enhanceEndpoints({
  endpoints: {
    GetAdminWhatsNewPreview: { providesTags: ['WhatsNew'] },
    GetAdminWhatsNewFeatures: { providesTags: ['WhatsNew'] },
    GetAdminWhatsNewReleases: { providesTags: ['WhatsNew'] },
    GetAdminWhatsNewEmailRecipients: { providesTags: ['WhatsNewEmail'] },
    GetAdminWhatsNewEmailDeliveries: { providesTags: ['WhatsNewEmail'] },
    AdminSetWhatsNewEmailRecipient: { invalidatesTags: ['WhatsNewEmail'] },
    AdminSaveWhatsNewFeature: { invalidatesTags: ['WhatsNew'] },
    AdminDeleteWhatsNewFeature: { invalidatesTags: ['WhatsNew'] },
    AdminSetWhatsNewReleaseEffectiveOn: { invalidatesTags: ['WhatsNew'] },
  },
});
